import { ApolloError } from 'apollo-client';
import {
    errorAccessDenied,
    errorNotFound,
    unauthenticated,
} from 'projects/components/ErrorBoundary';

function isApolloError(err: Error): err is ApolloError {
    return err.hasOwnProperty('graphQLErrors');
}

export function hasGraphQLError(error: Error | ApolloError | undefined, type: string): boolean {
    if (!error) {
        return false;
    }

    if (!isApolloError(error)) {
        return false;
    }

    return error.graphQLErrors.filter(m => m.message == type).length > 0;
}

export function handleGraphQLError(error: ApolloError) {
    if (hasGraphQLError(error, 'not_found')) {
        throw errorNotFound;
    }

    if (hasGraphQLError(error, 'access_denied')) {
        throw errorAccessDenied;
    }

    if (hasGraphQLError(error, 'unauthenticated')) {
        throw unauthenticated;
    }

    throw error;
}
